const MEDIAPIPE_VERSION = '0.10.14';
const MEDIAPIPE_CDN = `https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@${MEDIAPIPE_VERSION}`;
const MODEL_URL = 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';

// Positioning configuration for each Shopify product type.
// These values are initial estimates and may require visual calibration.
const AR_PRODUCT_CONFIG = {
  earrings: {
    tracking: 'face',
    anchors: [234, 434],
    widthFactor: 0.115,
    yOffsetFactor: 0.055,
    imageTopFactor: 0.18
  },

  'nose ring': {
    tracking: 'face',
    anchors: [1],
    widthFactor: 0.045,
    yOffsetFactor: 0,
    imageTopFactor: 0.5
  },

  'maang tikka': {
    tracking: 'face',
    anchors: [10],
    widthFactor: 0.09,
    yOffsetFactor: -0.015,
    imageTopFactor: 0.5
  },

  necklace: {
    tracking: 'face',
    anchors: [152],
    widthFactor: 0.62,
    yOffsetFactor: 0.12,
    imageTopFactor: 0.12
  },

  pendant: {
    tracking: 'face',
    anchors: [152],
    widthFactor: 0.28,
    yOffsetFactor: 0.24,
    imageTopFactor: 0.12
  },

  ring: {
    tracking: 'hand'
  },

  bracelet: {
    tracking: 'hand'
  },

  bangles: {
    tracking: 'hand'
  }
};

function normalizeProductType(value) {
  return (value || 'earrings')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');
}

function setupTryOn(modal) {
  const video = modal.querySelector('[data-ar-video]');
  const canvas = modal.querySelector('[data-ar-canvas]');
  const ctx = canvas.getContext('2d');

  const status = modal.querySelector('[data-ar-status]');
  const sizeInput = modal.querySelector('[data-ar-size]');
  const sizeValue = modal.querySelector('[data-ar-size-value]');
  const startButton = modal.querySelector('[data-ar-start]');
  const stopButton = modal.querySelector('[data-ar-stop]');

  let stream = null;
  let landmarker = null;
  let animationFrame = null;
  let lastVideoTime = -1;
  let overlay = null;
  let overlayUrl = '';
  let scale = Number(sizeInput.value);

  // Read the Shopify product type from the AR modal.
  const productType = normalizeProductType(
    modal.dataset.productType
  );

  // Use the matching configuration, or earrings as the fallback.
  const productConfig =
    AR_PRODUCT_CONFIG[productType] ||
    AR_PRODUCT_CONFIG.earrings;

  const setStatus = (message) => {
    status.textContent = message;
  };

  function resizeCanvas() {
    const rect = video.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    canvas.width = Math.max(
      1,
      Math.round(rect.width * dpr)
    );

    canvas.height = Math.max(
      1,
      Math.round(rect.height * dpr)
    );

    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function drawFrame() {
    if (!stream || video.readyState < 2) {
      animationFrame = requestAnimationFrame(drawFrame);
      return;
    }

    if (
      video.currentTime !== lastVideoTime &&
      landmarker
    ) {
      lastVideoTime = video.currentTime;

      const rect = video.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;

      ctx.clearRect(0, 0, width, height);

      try {
        const result = landmarker.detectForVideo(
          video,
          performance.now()
        );

        const face = result.faceLandmarks?.[0];

        if (
          face &&
          overlay?.complete &&
          overlay.naturalWidth > 0 &&
          productConfig.tracking === 'face'
        ) {
          // Select landmarks according to the product type.
          const anchors = (productConfig.anchors || [])
  .map((index) => face[index])
  .filter(Boolean)
  .map((point, index) => {
  // Keep the first earring unchanged.
  if (index === 1) return point;

  // Move only the second earring downward.
  return {
    ...point,
    x: point.x - 0.018,
    y: point.y + 0.10
  };
});

          const baseWidth = Math.max(
            12,
            width * productConfig.widthFactor * scale
          );

          const baseHeight =
            baseWidth *
            (overlay.naturalHeight / overlay.naturalWidth);

          anchors.forEach((point) => {
            const x = point.x * width;

            const y =
              point.y * height;
              // height * productConfig.yOffsetFactor;
              const isLeftAnchor = point === anchors[0];

const xOffset = width * 0.015;
const yOffset = height * 0.08;
const finalX = x + (isLeftAnchor ? -xOffset : xOffset);
const finalY = y - yOffset;
         ctx.drawImage(
  overlay,
  finalX - baseWidth / 2,
  finalY - baseHeight * productConfig.imageTopFactor,
  baseWidth,
  baseHeight
);
          });
        }
      } catch (error) {
        console.warn(
          'AR frame processing issue:',
          error
        );
      }
    }

    animationFrame = requestAnimationFrame(drawFrame);
  }

  async function loadOverlay() {
    const url = modal.dataset.overlayUrl;

    if (!url) {
      overlay = null;

      setStatus(
        'Choose a transparent jewellery overlay image in the product section settings to preview jewellery.'
      );

      return false;
    }

    if (overlay && overlayUrl === url) {
      return true;
    }

    overlayUrl = url;
    overlay = new Image();
    overlay.crossOrigin = 'anonymous';
    overlay.src = url;

    try {
      await overlay.decode();
      return true;
    } catch {
      overlay = null;

      setStatus(
        'Could not load the jewellery image. Check the product image or upload a transparent PNG.'
      );

      return false;
    }
  }

  async function startCamera() {
    if (!navigator.mediaDevices?.getUserMedia) {
      setStatus(
        'Camera access is unavailable. Use HTTPS and a supported modern browser.'
      );

      return;
    }

    startButton.disabled = true;
    setStatus('Loading face tracking…');

    try {
      const vision = await import(
        `${MEDIAPIPE_CDN}/vision_bundle.mjs`
      );

      const fileset =
        await vision.FilesetResolver.forVisionTasks(
          `${MEDIAPIPE_CDN}/wasm`
        );

      landmarker =
        await vision.FaceLandmarker.createFromOptions(
          fileset,
          {
            baseOptions: {
              modelAssetPath: MODEL_URL,
              delegate: 'GPU'
            },
            runningMode: 'VIDEO',
            numFaces: 1,
            outputFaceBlendshapes: false,
            outputFacialTransformationMatrixes: false
          }
        ).catch(async () =>
          vision.FaceLandmarker.createFromOptions(
            fileset,
            {
              baseOptions: {
                modelAssetPath: MODEL_URL
              },
              runningMode: 'VIDEO',
              numFaces: 1
            }
          )
        );

      await loadOverlay();

      stream =
        await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            facingMode: 'user',
            width: { ideal: 1280 },
            height: { ideal: 720 }
          }
        });

      video.srcObject = stream;
      await video.play();

      resizeCanvas();

      if (productConfig.tracking === 'hand') {
        setStatus(
          `Camera is on, but ${productType} requires hand tracking. This version currently supports face tracking only.`
        );
      } else {
        setStatus(
          overlay
            ? `Camera is on. Move your face slowly to preview ${productType} placement.`
            : 'Camera is on. Add a transparent AR overlay image to see jewellery.'
        );
      }

      cancelAnimationFrame(animationFrame);

      animationFrame =
        requestAnimationFrame(drawFrame);

    } catch (error) {
      console.error(error);

      const message =
        error?.name === 'NotAllowedError'
          ? 'Camera permission was denied. Allow camera access in your browser and try again.'
          : 'Could not start AR. Check your internet connection, camera permissions and browser support.';

      setStatus(message);

    } finally {
      startButton.disabled = false;
    }
  }

  function stopCamera() {
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }

    animationFrame = null;

    if (stream) {
      stream.getTracks().forEach(
        (track) => track.stop()
      );
    }

    stream = null;
    video.srcObject = null;

    ctx.clearRect(
      0,
      0,
      canvas.width,
      canvas.height
    );

    setStatus(
      'Camera stopped. Your camera stream is not sent to the store by this theme.'
    );

    startButton.disabled = false;
  }

  startButton.addEventListener(
    'click',
    startCamera
  );

  stopButton.addEventListener(
    'click',
    stopCamera
  );

  sizeInput.addEventListener('input', () => {
    scale = Number(sizeInput.value);

    sizeValue.textContent =
      `${scale.toFixed(2)}×`;
  });

  window.addEventListener(
    'resize',
    resizeCanvas
  );

  modal.addEventListener(
    'ar:close',
    stopCamera
  );

  return { stopCamera };
}

function init() {
  const modal = document.querySelector(
    '[data-ar-modal]'
  );

  if (!modal) return;

  setupTryOn(modal);

  document.querySelectorAll(
    '[data-ar-open]'
  ).forEach((button) => {
    button.addEventListener('click', () => {
      modal.dataset.overlayUrl =
        button.dataset.jewelleryImage || '';

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });

  const close = () => {
    modal.hidden = true;
    document.body.style.overflow = '';

    modal.dispatchEvent(
      new Event('ar:close')
    );
  };

  modal
    .querySelector('[data-ar-close]')
    ?.addEventListener('click', close);

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      !modal.hidden
    ) {
      close();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    init
  );
} else {
  init();
}